<template>

    <div v-if="!requisicoes.finalizado" class="loading-overlay">
        <div class="spinner"></div>
    </div>


    <div v-if="requisicoes.finalizado">

        <div class="title">
            <h3>Os campos com * são de preenchimento obrigatório</h3>
            <h5>Caso queira, você poderá salvar e continuar depois.</h5>
        </div>

        <div class="formulario">
            <div class="agrupamentoFormulario">
                <div class="categoriaAgrupamentoFormulario">
                    <LabelDisclaimer :TamanhoFonteLabel="'H5'" :NomeLabel="'Documentos'"
                        :TipoCliente="'Pessoa Jurídica'" :Sessao="'Documentos'" :SubSessao="'Documentos'" />
                    <span>Todos os arquivos marcados como obrigatórios, deverão ser anexados</span>
                </div>
                <div class="camposAgrupamentoFormulario">
                    <div class="row">
                        <div class="label__field" style="width: 80%">
                            <label class="label" for="nome">Tipo de documento*</label>

                            <div style="display: inline-flex; width: 100%">
                                <select id="tipoCadastro"
                                    style="width: 30% !important; height: 38px; margin-right: 20px;" class="field"
                                    v-model="TipoDocumento">
                                    <option value="">Selecione</option>
                                    <option v-for="item in listaDocumentosFiltrados" :key="item.Id" :value="item.Id">
                                        <span :style="{ background: item.Obrigatorio ? 'red' : 'none' }">{{ item.Nome
                                            }}{{ item.Obrigatorio == 'Sim' ? ' - Obrigatório' : '' }}</span>
                                    </option>
                                </select>


                                <div v-for="(documento, index) in listaDocumentosFiltradosComTipo" :key="index">
                                    <div class="label__field" style="width: 80%">
                                        <input type="file" :id="'fileInput' + index" :ref="'fileInput' + index"
                                            style="display: none" @change="handleFileChange($event, documento.Id)">
                                        <button class="btnBlueUpload" :style="getDocumentoStyle()"
                                            @click="triggerFileInput(index)">Anexar arquivo</button>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>








                </div>
            </div>

            <div style="margin-top: 30px;">

                <div class="formulario">

                    <div class="resumoForm">
                        <div>
                            <table class="table">
                                <thead>
                                    <th style="width: 20%">Tipo de documento</th>
                                    <th style="width: 15%">Nome do arquivo</th>
                                    <th style="width: 15%">Data/Hora</th>
                                </thead>
                                <tbody>
                                    <tr v-for="(arquivo, index) in arquivos" :key="index">
                                        <td>{{ getNomeDoDocumento(arquivo.TipoDocumentoId) }}</td>
                                        <td>{{ arquivo.FileName }}</td>
                                        <td>{{
                                            formatDateTime(arquivo.InsertDate)}}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                </div>
            </div>


        </div>

        <div class="footerFormulario">

            <div class="buttonsAcoes">
                <button class="btnDefault" @click="salvar">Salvar e continuar depois</button>
                <button class="btnBlue" v-if="!Edicao" @click="proximaEtapa">Avançar</button>
            </div>

        </div>

    </div>
</template>


<script>

import { mapGetters } from 'vuex';
import formatData from '@/utils/formatData';
import LabelDisclaimer from '../Utilitarios/Disclaimer/LabelDisclaimer.vue'

export default {
    mixins: [formatData],
    components: { LabelDisclaimer },
    name: 'CadastroPF_UploadDocumentos',
    props: ['Edicao'],
    computed: {
        ...mapGetters({
            user: 'auth/user',
            listaDocumentos: 'GET_LISTA_DOCUMENTOS_UPLOAD',
            listaDocumentosUploadEfetuado: 'GET_LISTA_DOCUMENTOS_UPLOAD_REALIZADO'
        }),
        listaDocumentosFiltrados() {
            return this.listaDocumentos.filter(
                documento => documento.TipoCliente === 'Pessoa Jurídica' || documento.TipoCliente === 'Todos'
            );
        },
        listaDocumentosFiltradosComTipo() {
            return this.listaDocumentos.filter(
                documento => (documento.TipoCliente === 'Pessoa Jurídica' || documento.TipoCliente === 'Todos') && documento.Id == this.TipoDocumento
            );
        },
    },
    data() {
        return {
            permitirAvancar: false,
            TipoDocumento: "",
            requisicoes: {
                listaDocumentos: false,
                listaDocumentosUploadEfetuado: false,
                finalizado: false
            },
            arquivosUpload: [],
            arquivos: [],
            arquivo: {
                ClienteId: null,
                TipoDocumentoId: '',
                FileName: '',
                Descricao: '',
                FileDataString64: '',
                UsuarioInsert: '',
                Data: new Date()
            },
        }
    },
    created() {
        this.$store.dispatch('FETCH_CONSULTA_LISTA_DOCUMENTOS_UPLOAD');
        this.$store.dispatch('FETCH_CONSULTA_LISTA_DOCUMENTOS_UPLOAD_REALIZADO', this.user.ClienteId);

    },
    mounted() {
        this.validarFormulario();
    },
    watch: {
        listaDocumentosUploadEfetuado() {
            this.verificarSeRequisicoesFinalizaram('listaDocumentosUploadEfetuado')
            if (this.listaDocumentosUploadEfetuado != null) {
                this.arquivosUpload = [];
                this.arquivos = this.listaDocumentosUploadEfetuado;
                this.validarFormulario();
            }

        },
        listaDocumentos() {
            this.verificarSeRequisicoesFinalizaram('listaDocumentos')
        }
    },
    methods: {
        verificarSeRequisicoesFinalizaram(requisicao) {
            if (requisicao == 'listaDocumentos') {
                this.requisicoes.listaDocumentos = true;
            } else if (requisicao == 'listaDocumentosUploadEfetuado') {
                this.requisicoes.listaDocumentosUploadEfetuado = true;
            }

            if (this.requisicoes.listaDocumentosUploadEfetuado && this.requisicoes.listaDocumentos) {
                this.requisicoes.finalizado = true;
            }

        },
        getNomeDoDocumento(tipoDocumentoId) {
            const documento = this.listaDocumentos.find(doc => doc.Id === tipoDocumentoId);
            return documento ? documento.Nome : 'Documento não encontrado';
        },
        validarFormulario(submeter) {
            this.permitirAvancar = true;
            var nomeDoCampo = '';

            this.listaDocumentos.forEach(obj => {
                if ((obj.TipoCliente == 'Pessoa Jurídica' || obj.TipoCliente == 'Todos') && obj.Obrigatorio == 'Sim') {
                    if (!this.arquivos.some(arquivo => arquivo.TipoDocumentoId === obj.Id)) {
                        if (this.permitirAvancar) {
                            nomeDoCampo = obj.Nome;
                        }
                        this.permitirAvancar = false;
                    }
                }

            });


            if (submeter && nomeDoCampo != '') {
                this.$swal({
                    icon: 'warning',
                    title: 'Oops...',
                    text: `O documento ` + nomeDoCampo + ` é obrigatório e não foi enviado, envie o documento para avançar`,
                });
            }

        },
        proximaEtapa() {
            this.validarFormulario(true);
            if (this.permitirAvancar) {
                this.$store.commit('SET_SALVAR_INFO_DES_NOTIFICACAO', true);
                this.$store.commit('SET_PJ_SALVAR_INFO', true);
                this.$store.commit('SET_ETAPA_CADASTRO', 7);
            }
        },
        triggerFileInput(index) {
            // Aciona o clique no input file correspondente ao documento
            this.$refs['fileInput' + index][0].click();
        },
        getDocumentoStyle() {
            return {
                color: 'white',
                backgroundColor: '#00235C',
                border: '1px solid #00235C'
            };
        },
        async excluirArquivo(documentoId) {

            const index = this.arquivos.findIndex(arquivo => arquivo.TipoDocumentoId === documentoId);


            this.arquivos.splice(index, 1);
            this.$store.commit('SET_SALVAR_INFO_UPLOAD', this.arquivos);
            this.validarFormulario();

        },
        salvarAlteracoesLocalmente() {
            this.$store.commit('SET_SALVAR_INFO_UPLOAD', this.arquivosUpload);
            this.validarFormulario();
            this.salvar();
        },
        salvar() {
            this.$store.commit('SET_PJ_SALVAR_INFO', true);
        },
        handleFileChange(event, id) {
            const file = event.target.files[0];
            if (file) {
                const reader = new FileReader();
                reader.onload = (e) => {
                    const base64String = e.target.result;
                    // Remover o prefixo "data:*/*;base64," se presente
                    const base64Data = base64String.split(',')[1];
                    this.novoArquivo = {
                        ClienteId: this.user.ClienteId,
                        TipoDocumentoId: id,
                        FileName: file.name,
                        Descricao: '',
                        FileDataString64: base64Data,
                        UsuarioInsert: this.user.NomeRazaoSocial
                    };
                    this.arquivosUpload.push({ ...this.novoArquivo });
                    this.TipoDocumento = '';
                    this.salvarAlteracoesLocalmente();
                };
                reader.readAsDataURL(file);
            }
            // Limpar o input
            event.target.value = null;
        }
    }
}

</script>


<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');

.btnBlueUpload {
    height: 40px;
    font-family: 'Inter', sans-serif;
    /* Fonte Inter */
    border-radius: 8px;
    /* Raio de borda */
    widows: 88px;
    cursor: pointer;
}


.formulario {
    width: 100%;
}

.agrupamentoFormulario {
    width: 100%;
    display: inline-flex;
    margin-top: 10px;
}

.categoriaAgrupamentoFormulario {
    width: 13%;
    margin-right: 15px;
    font-family: 'Inter', sans-serif;
    /* Fonte Inter */

    span {
        font-weight: 400 !important;
        font-size: 13px;
        color: #667085;
    }

}

.label__field {
    padding-right: 30px;
}

.camposAgrupamentoFormulario {
    width: 90%;

    .row {
        width: 100%;
        display: inline-flex;
        gap: 8px;
        margin-bottom: 10px;
    }

    .accept {
        display: inline-flex;

        &:checked {
            +label {
                &:before {
                    background: white;
                    border: 1px solid black;
                    transition: background 0.3s;
                }
            }

            +label {
                &::after {
                    opacity: 1;
                    transition: all;
                    background: transparent;
                }
            }
        }
    }



    .radio {
        display: flex;
        align-items: center;
        margin-right: 25px;

        @media (max-width: 768px) {
            margin-right: 0;
            margin-bottom: 20px;
        }

        .field__radio {
            width: 20px;
            height: 20px;
        }

        .fieldInRadio {
            border-radius: 8px;
            /* Raio de borda */
            border: 1px solid #D0D5DD;
            /* Borda */
            padding: 10px 14px;
            /* Preenchimento interno */
            background-color: #F9FAFB;
            /* Cor de fundo */
            width: 55%;
        }

        .label__radio {
            margin-left: 5px;
            margin-right: 40px;
            margin-top: 5px;
        }
    }

    select {
        width: 105% !important;
    }


    label {
        font-family: 'Inter', sans-serif;
        /* Fonte Inter */
        font-weight: 500;
        /* Peso médio */
        font-size: 14px;
        /* Tamanho da fonte */
        line-height: 20px;
        /* Altura da linha */
        color: #344054;
        /* Cor */
        display: block;
        /* Garante que a label fique acima do input */
        margin-bottom: 8px;
        /* Espaçamento entre a label e o input abaixo dela */
    }

}





.title {

    border-bottom: 1px solid #EAECF0;

    h3 {
        margin-top: 50px;
        color: #101828;
        font-weight: 500;
        font-family: 'Inter', sans-serif;

    }

    h5 {
        margin-top: 5px;
        margin-block-start: 0;
        color: #667085;
        font-weight: 400;
        font-family: 'Inter', sans-serif;
    }
}
</style>